import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { FiatTransaction as OldFiatTransactionModel } from "@models/transaction";
import { FiatWalletService } from "@main-services/wallet/fiat_wallet.service";
import {
	FiatTransaction,
	FiatTransactionAdapter
} from "@modules/+new/transactions/domain/entities/fiat-transaction.model";
import { map } from "rxjs/operators";

@Injectable({
	providedIn: "any"
})
export class TransactionsBridgeService {
	private fiatTransactionAdapter: FiatTransactionAdapter = new FiatTransactionAdapter();
	public constructor(private readonly fiatWalletService: FiatWalletService) {}

	public getFiatTransactions$(): Observable<FiatTransaction[]> {
		return this.fiatWalletService
			.getTransactions()
			.pipe(map((data: OldFiatTransactionModel[]) => this.fiatTransactionAdapter.adaptMany(data)));
	}

	public getFiatTransaction$(walletId: string, transactionId: string): Observable<FiatTransaction> {
		return this.fiatWalletService
			.getTransaction(walletId, transactionId)
			.pipe(map((data: OldFiatTransactionModel) => this.fiatTransactionAdapter.adapt(data)));
	}
}
